module.exports = __webpack_public_path__ + "static/img/mark5.2a0290c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark5.png
// module id = k+tN
// module chunks = 0